import React from 'react';
import { useNavigate } from 'react-router-dom';
import { siteConfig } from '../data/mock';
import { usePageMeta } from '../hooks/use-page-meta';
import { AboutStory } from '../components/about/AboutStory';
import { ServicesOverview } from '../components/about/ServicesOverview';
import { AboutCta } from '../components/about/AboutCta';

export const AboutPage = () => {
  const navigate = useNavigate();
  usePageMeta({
    title: 'About Elina',
    description: 'Meet Elina K., a Dubai-based family, newborn, maternity and couples photographer originally from Ukraine, living in Dubai since 2019.',
    path: '/about',
    image: siteConfig.aboutImage
  });

  return (
    <div className="min-h-screen bg-[#1a1a1a]" style={{ paddingTop: '100px' }} data-testid="about-page">
      <AboutStory />
      <ServicesOverview onViewGallery={(category) => navigate(`/gallery?category=${category}`)} />
      <AboutCta onBook={() => navigate('/contact')} />
    </div>
  );
};
